import { isDesktop } from '../desktop.ts';

export const useIsDesktop = (): {
	isDesktop: boolean;
} => {
	return {
		isDesktop: isDesktop(),
	};
};
